export enum MarketingActionActivationTypeEnum {
    Classic = "classic",
    CoFunded = "co-funded",
    AutoRule = "auto-rule",
    Schedulable = "schedulable",
    Special = "special",
    SmartScheduler = "smart-scheduler",
    OptimizedAutoRule = "optimized-auto-rule",
    NonParallel = "non-parallel",
}
